export const BASE_URL_API_TRANXT_UAT_API = `https://api.seobix.com`;
// export const BASE_URL_API_TRANXT_UAT_API = `https://apiuat.seobix.com`;
export const BASE_URL_API_TRANX_BLOG = `https://blogapi.bumppy.com/api/Bumppy`;